import { motion } from 'framer-motion';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { ActionInviteFriends } from './ActionInviteFriends';
import { ItemRanking } from './ItemRanking';

import { Paginator } from '@/components/Paginator';
import useAuth from '@/hooks/useAuth';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { TopRankingTDA } from '@/types/tda';
import { FADE_IN_OUT } from '@/utils';

export const RankingTable = ({
  dataTable,
  isGeneral,
  isFirstMathDayRanking,
  rankingAvailable,
}: {
  dataTable: TopRankingTDA[];
  isGeneral: boolean;
  isFirstMathDayRanking: boolean;
  rankingAvailable?: boolean;
}) => {
  const { isDesktop } = useIsDesktop();
  const [contentCurrentPage, setContentCurrentPage] = useState<TopRankingTDA[]>(
    []
  );
  const { userInitialData: user } = useAuth();

  const initState = useCallback(() => {
    if (dataTable.length > 0 && isDesktop) {
      setContentCurrentPage(dataTable.slice(0, 10));
    } else {
      setContentCurrentPage(dataTable);
    }
  }, [isDesktop, dataTable]);

  useEffect(() => {
    initState();

    return () => {
      setContentCurrentPage([]);
    };
  }, [initState]);

  const handleContentCurrentPage = (dts: TopRankingTDA[]) => {
    dts && setContentCurrentPage(dts);
  };

  const showInvite = useMemo(() => {
    return (
      dataTable.length === 1 &&
      dataTable.every((item) => item.idUsuarioDT === user?.idUsuarioDT)
    );
  }, [dataTable, user?.idUsuarioDT]);

  return (
    <div className="w-[calc(100%+2rem)] -left-4 relative lg:left-auto lg:w-auto">
      <div className="flex text-gdt-gray-4 font-bold text-xs lg:text-sm h-10 mt-4 lg:mt-3 items-center px-7 bg-gdt-gray-7 lg:bg-white">
        <p className="w-12 lg:w-[68px]">{isDesktop ? 'Posición' : 'Pos'}</p>
        {isGeneral && rankingAvailable && <p className="w-8">Dif.</p>}
        <p className="flex-1">DT</p>
        <p className="w-[68px] text-right lg:w-[200px] lg:text-center">
          Ganó fecha
        </p>
        <p className="w-[62px] text-right lg:w-[113px] lg:text-center">
          Puntos
        </p>
      </div>
      {dataTable && dataTable.length > 0 && (
        <motion.div animate={'show'} initial={'hide'} variants={FADE_IN_OUT}>
          <>
            <div className="lg:h-auto mt-6 rounded-lg bg-white">
              {contentCurrentPage.map((item: TopRankingTDA, index: number) => {
                return (
                  <ItemRanking
                    key={index + item.dt}
                    data={item}
                    isFirstMathDayRanking={isFirstMathDayRanking}
                    isGeneral={Boolean(item?.isGeneral)}
                    rankingAvailable={rankingAvailable}
                  />
                );
              })}
              {showInvite && isDesktop && (
                <div className="flex flex-col items-center h-[400px] mt-20">
                  <p className="text-base text-gdt-gray-2 font-semibold">
                    No hay amigos participando.
                  </p>
                  <ActionInviteFriends className="mt-2" />
                </div>
              )}
              {isDesktop && dataTable.length > 10 && (
                <Paginator
                  key={dataTable
                    .map((item) => item.nroPos + item.puntos)
                    .join('.')}
                  currentContentPage={handleContentCurrentPage}
                  items={dataTable}
                />
              )}
            </div>
          </>
        </motion.div>
      )}
    </div>
  );
};
